export const ERROR_SERIES_NONEXISTENT_OR_LOGGED_OUT =
  'Oh no! Either this series does not exist, or you do not have access to this series. You may need to log in to access it.'

export const ERROR_SERIES_NONEXISTENT_OR_NO_ACCESS =
  'Oh no! This series does not exist, or you do not have access to it.'

export const ERROR_SERIES_DELETED = `We're sorry! The series you are looking for has been deleted. Try joining another one!`
